<div class="flex h-full min-h-0 flex-col">
  <div class="border-b border-gray-200">
    <div class="px-8 h-20 items-center flex gap-3">
      @if (canGoBack()) {
        <ng-container [ngTemplateOutlet]="backArrow" />
      }
      <app-dropdown-label
        appBoardsViewsContextMenu
        [appBoardsViewsContextMenuFolders]="foldersOpen()"
        [appBoardsViewsContextMenuNavigate]="navigateCollection"
        (appBoardsViewsContextMenuOpened)="viewsMenuOpened.set($event)"
        [collapsed]="!viewsMenuOpened()"
      >
        {{ title() }}
      </app-dropdown-label>

      <div class="grow"></div>

      @if (foldersOpen()) {
        <app-context-menu-state-indicator svgIcon="filters" appBoardsFoldersListContextMenu />
        <app-search-state-indicator [applied]="!!folderSearch()" (clear)="folderSearch.set('')">
          <app-icon class="max-w-8 max-h-8 text-gray-500 cursor-pointer items-center" name="search-small"
            stchPopover stchPopoverPlacement="bottomRight" stchPopoverTrigger="click"
            [stchPopoverContent]="folderSearchPopover" />
        </app-search-state-indicator>
      } @else {
        <app-context-menu-state-indicator svgIcon="filters" appBoardsListContextMenu />

        <app-search-state-indicator [applied]="listStore.isSearchApplied()" (clear)="clearSearch()">
          <app-icon
            class="max-w-8 max-h-8 text-gray-500 cursor-pointer items-center"
            name="search-small"
            stchPopover
            stchPopoverPlacement="bottomRight"
            stchPopoverTrigger="click"
            [stchPopoverContent]="searchPopover"
            [stchPopoverFallbackPlacements]="[]"
            [stchPopoverShowUntil]="popoverClose"
          />
        </app-search-state-indicator>
      }
    </div>
  </div>

  @if (creationAllowed()) {
    <app-panel-board-create class="block px-4 py-2" [folderId]="listStore.folderId()" [beforeCreate]="beforeCreate" (created)="createdBoard($event)" />
  }

  @if (openedBoardId(); as boardId) {
    <div class="flex items-center justify-between border-b border-border px-4 py-2">
      <app-button2 appearance="secondary-text" size="s" data-test="boards-panel-back-to-boards" (click)="leaveBoard()">
        <app-icon name="chevron-left" />Back to {{ title() }}
      </app-button2>
    </div>
    <app-boards-preview class="block min-h-0 flex-1" [boardId]="boardId" (closed)="returnToList()" />
  }
  @if (!openedBoardId() && openedFolder(); as folder) {
    <app-boards-folder-preview class="block min-h-0 flex-1" [folder]="folder" [dp]="true" [selectAllRequest]="folderSelectAllRequest()"
      (contentsSelected)="folderSelectAllRequest.set(0)" (boardOpened)="open($event)" (closed)="navigateCollection('folders')" />
  } @else if (foldersOpen()) {
    <section class="flex min-h-0 flex-1 flex-col" aria-label="Board folders" [class.hidden]="!!openedBoardId()" [attr.inert]="openedBoardId() ? '' : null">
      @if (folderCreationAllowed()) {
        @if (folderFormOpen()) {
          <app-boards-quick-form placeholder="Untitled folder" [autofocus]="true" [createFromForm]="createFolderAction" (close)="folderFormOpen.set(false)" />
        } @else {
          <app-quick-action-button class="block px-4 py-2" label="New folder" hint="" ariaLabel="Add New Folder" (click)="folderFormOpen.set(true)" />
        }
      }
      <div class="flex min-h-0 flex-1 flex-col border-t border-gray-200">
        <app-boards-folders-list [search]="folderSearch()" (openFolder)="openFolder($event.id, $event.selectAll)"
          (boardCreated)="openFolder($event.folderId); createdBoard($event.boardId)" />
      </div>
    </section>
  } @else {
    @if (listStore.folderId() && !openedBoardId()) {
      <app-button2 appearance="secondary-text" size="s" (click)="navigateCollection('folders')"><app-icon name="chevron-left" />Back to folders</app-button2>
    }
    <div class="min-h-0 flex-1 border-gray-200" [class.border-t]="creationAllowed()" [class.hidden]="!!openedBoardId()" [attr.inert]="openedBoardId() ? '' : null">
      <app-boards-list [showHeader]="false" [drivesPreview]="false" (openBoard)="open($event.id)" (doubleClickBoard)="open($event.id)" />
    </div>
  }
</div>
<ng-template #backArrow>
  <app-button2
    appearance="secondary-ghost"
    size="s"
    data-test="boards-panel-back"
    [ariaLabel]="backLabel()"
    [matTooltip]="backLabel()"
    (click)="goBack()"
  >
    <app-icon name="chevron-left" />
    @if (openedBoardId()) { <span class="truncate">{{ backLabel() }}</span> }
  </app-button2>
</ng-template>

<ng-template #searchPopover>
  <app-boards-search-popover [width]="420" [beforeApply]="mayLeave" (onSearch)="finishSearch()" (onCancel)="closeSearchPopover()" />
</ng-template>

<ng-template #folderSearchPopover>
  <label class="block p-4">
    <span class="block mb-2">Search folders</span>
    <input class="w-full rounded border border-border px-3 py-2" type="search" placeholder="Search folders" [value]="folderSearch()" (input)="searchFolders($event)" />
  </label>
</ng-template>
